import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import { useEffect, useState } from 'react';
import type { RouterContext } from '../app/router';
import { bootstrapSession } from '../features/auth/api';
import { useAuth } from '../features/auth/auth-context';

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  const { setSession } = useAuth();
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const session = await bootstrapSession();
      if (cancelled) return;
      if (session) setSession(session);
      setHydrated(true);
    })();
    return () => {
      cancelled = true;
    };
  }, [setSession]);

  if (!hydrated) return null;

  return (
    <>
      <Outlet />
      {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />}
    </>
  );
}
